module.exports = __webpack_public_path__ + "static/twitter-d1475114822be9cb1657caf4d29c94ee.png";